import { render } from "./cj_products_explorer.vue?vue&type=template&id=38fd4930&scoped=true"
import script from "./cj_products_explorer.vue?vue&type=script&lang=js"
export * from "./cj_products_explorer.vue?vue&type=script&lang=js"

import "./cj_products_explorer.vue?vue&type=style&index=0&id=38fd4930&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fd4930"]])

export default __exports__